export default "__VITE_ASSET__CL$$JM1I__"